import { render } from "./GeoRegioni.vue?vue&type=template&id=926c1540&scoped=true"
import script from "./GeoRegioni.vue?vue&type=script&lang=js"
export * from "./GeoRegioni.vue?vue&type=script&lang=js"

import "./GeoRegioni.vue?vue&type=style&index=0&id=926c1540&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-926c1540"]])

export default __exports__